import angular from 'angular';
import AdvertService from './advert.service.js';
import AdvertSchema from './advert.schema.js';

let advertModule = angular.module('advert', [])

    .service('AdvertService', AdvertService)
    .constant('AdvertSchema', AdvertSchema)
    .name;

export default advertModule;
